import { Visibility, VisibilityOff } from '@mui/icons-material';
import { FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput } from '@mui/material';
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { useForm } from 'react-hook-form';

const LoginForm = forwardRef((props, ref) => {
  const [showPassword, setShowPassword] = useState(false);
  const { onSubmit } = props;
  const { register, handleSubmit, formState } = useForm({
    defaultValues: {
      email: '',
      password: '',
    },
  });

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  useImperativeHandle(ref, () => ({
    handleSubmitForm: () => {
      handleSubmit((data) =>
        onSubmit({
          email: data.email,
          password: data.password,
        })
      )();
    },
  }));

  return (
    <form>
      <FormControl error={!!formState.errors.email} margin='normal' variant='outlined' fullWidth>
        <InputLabel htmlFor='outlined-username'>Электронная почта</InputLabel>
        <OutlinedInput
          id='outlined-username'
          label='Электронная почта'
          variant='outlined'
          fullWidth
          placeholder='Введите свою электронную почту'
          {...register('email', {
            required: true,
            setValueAs: (v) => (typeof v === 'string' ? v.trim() : v),
            pattern: /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/,
          })}></OutlinedInput>
      </FormControl>
      <FormControl error={!!formState.errors.password} margin='normal' variant='outlined' fullWidth>
        <InputLabel htmlFor='outlined-adornment-password'>Пароль</InputLabel>
        <OutlinedInput
          id='outlined-adornment-password'
          type={showPassword ? 'text' : 'password'}
          label='Пароль'
          variant='outlined'
          fullWidth
          placeholder='Укажите ваш пароль'
          autoComplete='new-password'
          endAdornment={
            <InputAdornment position='end'>
              <IconButton edge='end' aria-label='toggle password visibility' onClick={handleClickShowPassword}>
                {showPassword ? <Visibility fontSize='small' /> : <VisibilityOff fontSize='small' />}
              </IconButton>
            </InputAdornment>
          }
          {...register('password', {
            required: true,
            setValueAs: (v) => (typeof v === 'string' ? v.trim() : v),
          })}></OutlinedInput>
      </FormControl>
    </form>
  );
});

export default LoginForm;
